import React, { Component } from 'react'


class CollapsibleStep extends Component {
  render () {
    const {
      show,
      children,
    } = this.props

    return (
      <div className="project-stepper-container">
        <div className={`collapse ${show ? 'show' : ''}`}>
          {children}
        </div>
      </div>
    )
  }
}

export default CollapsibleStep
